/**
 * RangeSlider
 */
 import React, { Component } from 'react';
 import ReactDOM from 'react-dom';
 
 import InputRange from 'react-input-range';
 require('react-input-range/lib/css/index.css');
 
 class RangeSlider extends Component {
   constructor(props) {
     super(props);
     const _min = parseFloat(props.min);
     const _max = parseFloat(props.max); 
     let _values = [];
     if (props.value && Array.isArray(props.value)){
       if (props.value.length === 1 && props.value[0].indexOf(",") > -1) { // it means value is like ["10,20"]
         _values[0] = parseFloat(props.value[0].split(",")[0]);
         _values[1] = parseFloat(props.value[0].split(",")[1]);
       } else if (props.value.length === 2) { // it means value is like ["10","20"]
          _values = props.value && Array.isArray(props.value) ? props.value.map(val => {return parseFloat(val);}) : [];
       }
     } 
     if (_values.length < 1) { 
       _values[1] = _values[0];
     }
     let _valMin = _values[0];
     let _valMax = _values[1];
     // If the current value is out of the range, reset the value
     // to the default value. #11221
     // if the value is not in between min/max, update the value to the nearest edge.
     if (_valMin < _min || _valMax > _max) {
       if (_valMin < _min) {
         _valMin = _min;
       } else if (_valMax > _max) {
         _valMax = _max;
       }
     }
     const __values = {"min" : parseFloat(_valMin), "max" : parseFloat(_valMax)}; 
     this.state = {
       value: __values
     };
   }
  
   render(){
    const _min = parseFloat(this.props.min);
    const _max = parseFloat(this.props.max);
    let _step = this.props.step;
    if(_step !== null && _step !== null && _step !== "") {
      _step = parseFloat(_step);
    } else {
      _step = 1;
    }
    return (
        <InputRange 
          minValue={_min}
          maxValue={_max}
          step={_step}
          allowSameValue={false}
          name={"v-" + this.props.name}
          ref={"input-range"}
          value={this.state.value}
          disabled={this.props.disabled}
          onChange={(value) => {
            this.setState({value: value});
            this.props.onChange(value, true/*ignoreInteractive*/);
          }}
          onChangeComplete={(value) => {
            this.setState({value: value});
            this.props.onChangeComplete(value);
          }}
          />
    );
   }
 }
 export default RangeSlider;
 
 
 
 